import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import H6 from 'UIComponents/elements/headings/H6';
import { Table, TopHeaderCell } from './FeatureStyledComponents';

const FeaturesTableHeader = ({
  headerKeys
}) => {
  return /*#__PURE__*/_jsx(Table, {
    children: /*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx(TopHeaderCell, {}), headerKeys.map((headerKey, i) => /*#__PURE__*/_jsx(TopHeaderCell, {
          "data-key": i - 1,
          children: /*#__PURE__*/_jsx(H6, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `upgrades.productCatalog.tableHeader.${headerKey}`
            })
          })
        }, i))]
      })
    })
  });
};

export default FeaturesTableHeader;